import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = {
  class: "link-list",
  "data-qa": "Liste-liens-admin"
}
const _hoisted_3 = { class: "link-text" }
const _hoisted_4 = { class: "link-title" }
const _hoisted_5 = {
  key: 0,
  class: "link-subtitle"
}
const _hoisted_6 = { class: "actions" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 0,
  class: "newEntry"
}
const _hoisted_9 = { for: "nameLink" }
const _hoisted_10 = { for: "link" }
const _hoisted_11 = { for: "file" }
const _hoisted_12 = { class: "footer" }
const _hoisted_13 = { for: "nameLink" }
const _hoisted_14 = { for: "link" }
const _hoisted_15 = { for: "file" }
const _hoisted_16 = { class: "footer" }

import { useI18n } from 'vue-i18n';
import { UseStoreAdmin } from '@/store/adminStore';
import { computed, nextTick, ref } from 'vue';
import { UseStoreUser } from '@/store/userStore';
import { ACCEPTED_IMAGE_TYPES, LINK_TEXT_PLACEHOLDER } from '@/constants/liens';


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminLiensUtil',
  setup(__props) {

const isAddButtonDisabled = ref<boolean | null>(false);
const acceptedTypes = ref(ACCEPTED_IMAGE_TYPES);
const { t } = useI18n();
const linkToDelete = ref<string | null>(null);
const isDeleteClick = ref(false);
const adminStore = UseStoreAdmin();
const userStore = UseStoreUser();
const newEntry = ref<{
  name: string;
  url: string;
  file: File | null;
}>({
  name: '',
  url: '',
  file: null,
});
const isNew = ref(false);
const editableLink = ref<string | null>(null);
const targetSection = ref<HTMLElement | null>(null);
const editableValue = ref<any>();
const uploadEdit = ref<boolean>(false);
const isCreateDisabled = computed(() => shouldDisable(false));
const isEditDisabled = computed(() => {
  return !isValidEntry(editableValue.value, true);
});
const removeFile = () => {
  editableValue.value = {
    ...editableValue.value,
    file: null,
    imageBase64: '',
    s3Key: '',
  };
  uploadEdit.value = true;
};

function createNewEntry() {
  isAddButtonDisabled.value = true;
  editableLink.value = null;
  isNew.value = true;
  nextTick(() => {
    targetSection.value?.scrollIntoView({ behavior: 'smooth' });
  });
}
function updateValue(event: string, field: string) {
  editableValue.value = {
    ...editableValue.value,
    [field]: event,
  };
}
function createValue(event: string, field: string) {
  newEntry.value = {
    ...newEntry.value,
    [field]: event,
  };
}
function changeFile(file: any, isupdate: boolean = false) {
  if (
    file &&
    (file.type.startsWith('image/') || file.type == 'application/octet-stream')
  ) {
    if (isupdate) {
      editableValue.value = {
        ...editableValue.value,
        file: file,
      };
    } else {
      newEntry.value = {
        ...newEntry.value,
        file: file,
      };
    }
  }
}
async function saveAdmin() {
  isAddButtonDisabled.value = false;
  const userId = userStore.user.id;
  if (!userId) return;

  await adminStore.createAdminLink({
    name: newEntry.value.name,
    url: newEntry.value.url,
    userId,
    ...(newEntry.value.file ? { file: newEntry.value.file } : {}),
  });

  newEntry.value = {
    name: '',
    url: '',
    file: null,
  };

  isNew.value = false;
}

function cancel(isUpdate: boolean = false) {
  isAddButtonDisabled.value = false;
  if (isUpdate) {
    editableLink.value = null;
    editableValue.value = null;
    uploadEdit.value = false;
  } else {
    newEntry.value = {
      name: '',
      url: '',
      file: null,
    };
    isNew.value = false;
  }
}
function base64ToFile(base64: string, filename: string): File {
  if (base64.startsWith('data:application/octet-stream')) {
    if (base64.includes('svg')) {
      base64 = base64.replace('application/octet-stream', 'image/svg+xml');
    } else {
      base64 = base64.replace('application/octet-stream', 'image/png');
    }
  }

  const arr = base64.split(',');
  const mimeMatch = arr[0].match(/:(.*?);/);

  if (!mimeMatch) {
    throw new Error('Invalid base64 format');
  }

  const mime = mimeMatch[1];
  const byteString = atob(arr[1]);
  const u8arr = new Uint8Array(byteString.length);

  for (let i = 0; i < byteString.length; i++) {
    u8arr[i] = byteString.charCodeAt(i);
  }

  return new File([u8arr], filename, { type: mime });
}
function editLink(link: any) {
  isAddButtonDisabled.value = true;
  isNew.value = false;
  editableLink.value = link.id;
  editableValue.value = { ...link };
  uploadEdit.value = false;
  setTimeout(() => {
    const file = base64ToFile(
      editableValue.value.imageBase64,
      editableValue.value.s3Key
    );
    if (file) {
      editableValue.value = {
        ...editableValue.value,
        file: file,
      };
    }
  }, 1000);
}

function isValidUrl(url: string): boolean {
  try {
    const parsed = new URL(url);
    return ['http:', 'https:'].includes(parsed.protocol);
  } catch {
    return false;
  }
}

async function update() {
  isAddButtonDisabled.value = false;
  await adminStore.updateLinkByAdmin({
    ...editableValue.value,
    userId: userStore.user.id,
  });
  editableLink.value = null;
  editableValue.value = null;
}

function isValidEntry(
  entry: { name?: string; url?: string; file?: File },
  requireFile: boolean
): any {
  return (
    entry.name?.trim() &&
    entry.url?.trim() &&
    isValidUrl(entry.url) &&
    (!requireFile || (entry.file && entry.file.size > 0))
  );
}
function shouldDisable(isUpdate: boolean): boolean {
  return !isValidEntry(
    isUpdate ? editableValue.value : newEntry.value,
    !isUpdate
  );
}

function confirmDelete(linkId: string): void {
  adminStore.deleteAdminLink(linkId);
  isDeleteClick.value = false;
  linkToDelete.value = null;
}

function getCancelActions(_linkId: string) {
  return [
    {
      text: t('panel.Cancel'),
      callback: () => {
        linkToDelete.value = null;
      },
    },
  ];
}

function getMainActions(linkId: string) {
  return [
    {
      text: t('panel.Delete'),
      status: 'destructive',
      callback: () => {
        confirmDelete(linkId);
      },
    },
  ];
}

return (_ctx: any,_cache: any) => {
  const _component_cs_message = _resolveComponent("cs-message")!
  const _component_cs_button = _resolveComponent("cs-button")!
  const _component_cs_modal = _resolveComponent("cs-modal")!
  const _component_CsInputText = _resolveComponent("CsInputText")!
  const _component_cs_file_card = _resolveComponent("cs-file-card")!
  const _component_cs_upload = _resolveComponent("cs-upload")!
  const _component_cs_file_drop_zone = _resolveComponent("cs-file-drop-zone")!
  const _directive_modelValue = _resolveDirective("modelValue")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_cs_message, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('panel.csMessageAdmin')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", null, _toDisplayString(_unref(t)('panel.titleLienUtilAdmin')), 1),
      _createVNode(_component_cs_button, {
        class: "btn-new-link",
        icon: "ajouter",
        type: "secondary",
        text: _unref(t)('modal.nouveauLien'),
        onClick: createNewEntry,
        "data-qa": "add-link",
        disabled: isAddButtonDisabled.value
      }, null, 8, ["text", "disabled"])
    ]),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(adminStore).adminLinks, (link) => {
        return (_openBlock(), _createElementBlock("li", {
          key: link.id,
          class: _normalizeClass(['link-item', { 'edit-link': editableLink.value === link.id }])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("strong", _hoisted_4, _toDisplayString(link.name), 1),
            (editableLink.value !== link.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(link.url), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_cs_button, {
              "aria-label": _unref(t)('links.editLink', { name: link.name }),
              title: _unref(t)('links.editLink', { name: link.name }),
              icon: "modifier",
              type: "tertiary",
              size: "tiny",
              "data-cy-id": "button-success-7",
              onClick: ($event: any) => (editLink(link))
            }, null, 8, ["aria-label", "title", "onClick"]),
            _createVNode(_component_cs_button, {
              "aria-label": _unref(t)('links.deleteLink', { name: link.name }),
              title: _unref(t)('links.deleteLink', { name: link.name }),
              type: "secondary",
              icon: "supprimer",
              size: "small",
              status: "destructive",
              onClick: ($event: any) => (linkToDelete.value = link.id)
            }, null, 8, ["aria-label", "title", "onClick"]),
            (linkToDelete.value === link.id)
              ? (_openBlock(), _createBlock(_component_cs_modal, {
                  key: 0,
                  class: "confirmation-popup-delete",
                  "data-qa": "confirmation-popup-delete",
                  "is-opened": linkToDelete.value === link.id,
                  title: _unref(t)('modal.titleDeleteModal'),
                  "cancel-actions": getCancelActions(link.id),
                  "main-actions": getMainActions(link.id)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: "Confirm-text",
                      innerHTML: _unref(t)('modal.confirmDeleteLienByAdmin', { url: link.url })
                    }, null, 8, _hoisted_7)
                  ]),
                  _: 2
                }, 1032, ["is-opened", "title", "cancel-actions", "main-actions"]))
              : _createCommentVNode("", true)
          ]),
          (editableLink.value == link.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(t)('modal.labelName')), 1),
                _createVNode(_component_CsInputText, {
                  id: "nameLink",
                  category: "primary",
                  disabled: false,
                  minLength: "0",
                  maxLength: "50",
                  size: "regular",
                  placeholder: 'Ex: Cegedim Business Services',
                  modelValue: editableValue.value.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (updateValue($event, 'name')))
                }, null, 8, ["modelValue"]),
                _createElementVNode("label", _hoisted_10, _toDisplayString(_unref(t)('modal.labelLien')), 1),
                _createVNode(_component_CsInputText, {
                  id: "link",
                  category: "primary",
                  disabled: false,
                  minLength: 0,
                  size: "regular",
                  placeholder: _unref(LINK_TEXT_PLACEHOLDER),
                  modelValue: editableValue.value.url,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (updateValue($event, 'url')))
                }, null, 8, ["placeholder", "modelValue"]),
                _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(t)('modal.labelImage')), 1),
                (!uploadEdit.value)
                  ? (_openBlock(), _createBlock(_component_cs_file_card, {
                      key: 0,
                      "file-name": editableValue.value.s3Key,
                      format: "line"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_cs_button, {
                          icon: "effacer",
                          type: "tertiary",
                          status: "default",
                          onClick: removeFile
                        })
                      ]),
                      _: 1
                    }, 8, ["file-name"]))
                  : _createCommentVNode("", true),
                (uploadEdit.value)
                  ? (_openBlock(), _createBlock(_component_cs_upload, {
                      key: 1,
                      "show-file-name": "",
                      accept: acceptedTypes.value,
                      allowedTypes: acceptedTypes.value,
                      modelValue: editableValue.value.file,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editableValue.value.file) = $event)),
                      onChange: _cache[3] || (_cache[3] = ($event: any) => (changeFile($event, true)))
                    }, null, 8, ["accept", "allowedTypes", "modelValue"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_cs_button, {
                    type: "secondary",
                    text: _unref(t)('panel.Cancel'),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (cancel(true))),
                    "data-qa": "cancel-button"
                  }, null, 8, ["text"]),
                  _createVNode(_component_cs_button, {
                    icon: "enregistrer",
                    type: "primary",
                    text: _unref(t)('modal.saveUpdate'),
                    onClick: update,
                    "data-qa": "save-button",
                    disabled: isEditDisabled.value
                  }, null, 8, ["text", "disabled"])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ]),
    (isNew.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "targetSection",
          ref: targetSection,
          class: "newEntry"
        }, [
          _createElementVNode("h3", null, _toDisplayString(_unref(t)('modal.nouveauLien')), 1),
          _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(t)('modal.labelName')), 1),
          _withDirectives(_createVNode(_component_CsInputText, {
            id: "nameLink",
            category: "primary",
            disabled: false,
            minLength: "0",
            maxLength: "50",
            size: "regular",
            placeholder: 'Ex :Cegedim Business Services',
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (createValue($event, 'name')))
          }, null, 512), [
            [_directive_modelValue, newEntry.value.name]
          ]),
          _createElementVNode("label", _hoisted_14, _toDisplayString(_unref(t)('modal.labelLien')), 1),
          _withDirectives(_createVNode(_component_CsInputText, {
            id: "link",
            category: "primary",
            disabled: false,
            minLength: 0,
            size: "regular",
            placeholder: _unref(LINK_TEXT_PLACEHOLDER),
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (createValue($event, 'url')))
          }, null, 8, ["placeholder"]), [
            [_directive_modelValue, newEntry.value.url]
          ]),
          _createElementVNode("label", _hoisted_15, _toDisplayString(_unref(t)('modal.labelImage')), 1),
          _createVNode(_component_cs_file_drop_zone, {
            id: "file",
            acceptedTypes: acceptedTypes.value,
            onChange: changeFile
          }, null, 8, ["acceptedTypes"]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_cs_button, {
              type: "secondary",
              text: _unref(t)('panel.Cancel'),
              onClick: _cache[7] || (_cache[7] = ($event: any) => (cancel(false))),
              "data-qa": "cancel-button"
            }, null, 8, ["text"]),
            _createVNode(_component_cs_button, {
              icon: "enregistrer",
              type: "primary",
              text: _unref(t)('panel.Save'),
              onClick: saveAdmin,
              "data-qa": "save-button",
              disabled: isCreateDisabled.value
            }, null, 8, ["text", "disabled"])
          ])
        ], 512))
      : _createCommentVNode("", true)
  ], 64))
}
}

})